import React from 'react';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';

interface TabsProps {
  currentTabRoutes: Array<{ path: string; code: string }>;
  t: (key: string) => string;
}

const Tabs = ({ currentTabRoutes, t }: TabsProps) => (
  <div className="sticky top-0 z-10 flex gap-4 p-2 overflow-x-auto bg-inputBackground">
    {currentTabRoutes.map((item) => (
      <NavLink
        key={item.path}
        to={item.path}
        className={({ isActive }) =>
          clsx(
            'rounded-md py-1.5 px-3 text-sm font-medium',
            isActive ? 'bg-neutral-40 text-white' : 'text-neutral-40',
          )
        }
      >
        {t(`${item.code}`)}
      </NavLink>
    ))}
  </div>
);

export default React.memo(Tabs);
